import { render, staticRenderFns } from "./GeneralSampleInformation.vue?vue&type=template&id=00241fea"
import script from "./GeneralSampleInformation.vue?vue&type=script&lang=js"
export * from "./GeneralSampleInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports